module.exports = __webpack_public_path__ + "static/img/PFK_OurStory_Photo2_320x400.781f9d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PFK_OurStory_Photo2_320x400.jpg
// module id = 255
// module chunks = 1